module.exports = __webpack_public_path__ + "img/s8.cde330a6.jpg";